import { of, switchMap, from } from 'rxjs';
import { retry } from 'rxjs/operators';

import { postText, authorizedFetch, readJson } from './http.js';

export function findKnowledge(storeName, context) {
    if (context) {
        return postText(`/api/find-knowledge/${encodeURIComponent(storeName)}`, context).pipe(
            retry({
                count: 3,
                delay: 3000 + 1000*Math.random(),
            }),
        );
    } else {
        return of([]);
    }
}

export function exportKnowledge(storeName) {
    return of(undefined).pipe(
        switchMap(() => from(authorizedFetch(`/api/export-knowledge/${storeName}`))),
        readJson(),
    );
}
